import {Component, OnDestroy, OnInit} from "@angular/core";
import {UntypedFormControl} from "@angular/forms";
import {PreguntaModelDTO} from "@Models";
import {Subscription} from "rxjs";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-puntos-extras",
    templateUrl: "./tipo-pregunta-puntos-extras.component.html",
    styleUrls: ["./tipo-pregunta-puntos-extras.component.scss"]
})
export class TipoPreguntaPuntosExtrasComponent extends TipoPreguntaComponent implements OnInit, OnDestroy {
    public pregunta: PreguntaModelDTO;
    public puntosExtraControl = new UntypedFormControl();

    private subs = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService) {
        super();
    }

    public ngOnInit(): void {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
        if (this.pregunta.Payload == null) {
            this.pregunta.Payload = {
                score_earning: 0
            };
        } else {
            this.puntosExtraControl.setValue(this.pregunta.Payload.score_earning);
        }
        this.subs.add(
            this.puntosExtraControl.valueChanges.subscribe(() => {
                this.pregunta.Payload = {
                    ...this.pregunta.Payload,
                    score_earning: this.puntosExtraControl.value
                };
            })
        );
    }

    public ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
